angular.module('unergie.main')
.controller('sendinblueSubscriptionsModalCtrl', ($scope, $uibModalInstance, DataAccess, AlertManager, ErrorCatcher, id_account) => {
    $scope.fetching = true

    DataAccess.fetchAccountSubscriptions({ id_account }).$promise
    .then((subscriptions) => {
        $scope.subscriptions = subscriptions
    })
    .catch(ErrorCatcher)
    .finally(() => {
        $scope.fetching = false
    })

    $scope.close = $uibModalInstance.dismiss
    $scope.ok = () => {
        $scope.updating = true
        const payload = _.keyBy($scope.subscriptions, 'id')
        _.each(payload, (value, key) => {
            payload[key] = value.value
        })
        return DataAccess.modifyAccountSubscriptions({ id_account }, payload).$promise
        .then(() => {
            AlertManager.success('Abonnements mis à jour')
            $uibModalInstance.close()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.updating = false
        })
    }
})
